export const boardCopilotSettingsTour = {
  key: "boardCopilotSettings",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-copilot-wallet"]',
      content: t("Tour_BoardCopilotSettings_Wallet"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-copilot-behavior"]',
      content: t("Tour_BoardCopilotSettings_Behavior"),
      placement: "center",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-copilot-categories"]',
      content: t("Tour_BoardCopilotSettings_Categories"),
      placement: "top",
      disableBeacon: true,
    },
  ],
};
